import { Component, OnInit } from '@angular/core';
import { MyClientSignaturesConstants } from './constants/my-client-signatures.constants';
import { DocumentSearchResult } from '../document/models/documentSearchResult';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { MyClientSignaturesService } from './services/my-client-signatures.service';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-client-signatures',
  templateUrl: './my-client-signatures.component.html',
  styleUrls: ['./my-client-signatures.component.scss'],
})
export class MyClientSignaturesComponent implements OnInit {
  topBarTitle: string = MyClientSignaturesConstants.TopBarTitle;
  showAllLabel: string = MyClientSignaturesConstants.ShowAllLabel;
  isIncludeAll = MyClientSignaturesConstants.IsIncludeAll;
  showInformationIconCheckbox =
    MyClientSignaturesConstants.ShowInformationIconCheckbox;
  inactiveTooltip: string = MyClientSignaturesConstants.CheckBoxHoverToolTip;
  documentSearchResult: DocumentSearchResult[] = [];
  panelListType: string =
    DocumentLibraryConstants.InternalClientContacts_PanelListType;
  showLoader: boolean = true;
  isScreenAccessible: boolean = true;
  errorMessage!: string;

  constructor(private myClientSignaturesService: MyClientSignaturesService) {}

  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }

  includeInactive(isIncludeAll: boolean) {
    this.showLoader = true;
    this.getPanelListData(isIncludeAll);
  }

  getPanelListData(isIncludeAll: boolean) {
    this.myClientSignaturesService
      .getMyClientSignatures(isIncludeAll)
      .subscribe({
        error: (err) => {
          if (err.status === LabelConstants.Forbidden_StatusCode) {
            this.errorMessage = err.error.detail;
          }
          this.isScreenAccessible = false;
        },
        next: (serviceData) => {
          (this.documentSearchResult = serviceData), (this.showLoader = false);
        },
      });
  }
}
